import api from '../index';

const validate = (token: string) => {
    return api.get(`/invitation/validate?token=${encodeURIComponent(token)}`);
};

const accept = (token: string, password: string) => {
    return api.post(`/invitation/accept`, { token, password });
};

const InvitationApi = { validate, accept };
export default InvitationApi;
